<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <!-- This title changes based on Sync Field Title. eg; Customers Field Mapping, Invoices Field Mapping-->
        <h2>{{data?.module | titlecase }} Field Mapping</h2> 
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular"
            (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <div class="flx-modal__body p-0">
        <p-table [value]="tableData" [tableStyle]="{ 'min-width': '50rem' }">
            <ng-template pTemplate="header">
                <tr>
                    <th>FieldEx Field</th>
                    <th>QuickBooks Field</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-mappedData>
                <tr class="text-12 font-medium">
                    <td>{{ mappedData.fieldExField }}</td>
                    <td>{{ mappedData.qbField }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>

     <div class="flx-modal__footer">
        <button type="button"class="custella-btn-white" (click)="onCancelClick()">{{translate?.general.buttons.cancel.singular}}</button>
    </div>
</div>